import { TelemetrySettings } from '@/lib/services/telemetry.service';
import { JsonObject, removeSlashes } from '../../helpers';
import { TelemetryModel } from './telemetry.model';
import { object, string } from 'yup';
import { TelemetrySourceTypes } from './telemetry-sources';
import AwsIcon from '@/assets/telemetry-icons/aws.svg';

export type AwsS3TelemetryConfig = {
  bucketName: string;
  bucketRegion: string;
  keyPrefix: string;
};

export class AwsS3TelemetryModel extends TelemetryModel {
  config: AwsS3TelemetryConfig;

  constructor(props: JsonObject = {}) {
    super(props);

    const data = props as Record<keyof TelemetryModel, unknown>;

    this.type = 's3';
    this.typeLabel = 'AWS S3 Bucket';
    this.iconImage = AwsIcon;
    this.config = (data.config as AwsS3TelemetryConfig) || {
      bucketName: '',
      bucketRegion: '',
      keyPrefix: '',
    };

    this.canTest = true;

    this.schema = this.schema.concat(
      object({
        connectorId: string().required('Connector is required'),
        config: object({
          bucketName: string().required('S3 Bucket name is required'),
          bucketRegion: string().required('S3 Bucket region is required'),
          keyPrefix: string(),
        }),
      })
    );
  }

  getDestinationUrl(settings: TelemetrySettings, sourceType: TelemetrySourceTypes = 'user-event') {
    const { userEvents, auditEvents } = settings.destinations.schemaVersions;
    const isUserEvent = sourceType === 'user-event';

    const eventSetting = isUserEvent ? userEvents : auditEvents;
    const configVersion = isUserEvent
      ? this.telemetryTypes.userEvents.schemaVersion
      : this.telemetryTypes.auditEvents.schemaVersion;

    const version = eventSetting.supported.find(({ version }) => version === configVersion);
    const { s3Prefix = '' } = version || {};
    const { bucketName, keyPrefix = '' } = this.config;

    return [`s3://${bucketName || '<bucket-name>'}`, keyPrefix, s3Prefix]
      .map(removeSlashes)
      .filter((val) => val)
      .join('/');
  }
}
